import React from "react";
import {
    Navigate,
    Routes,
    Route
} from "react-router-dom";

import { useAuth } from "../../contexts/AuthContext";
import { useBrand } from "../context/BrandContext";
import { BrandProductProvider } from "../context/BrandProductContext";
import { CartProvider } from "../context/CartContext";

import BrandSetupWizard from "../setup/BrandSetupWizard";
import BrandDashboard from "./BrandDashboard";

import BrandOverview from "./BrandOverview";
import BrandProducts from "./BrandProducts";
import BrandServices from "./BrandServices";
import BrandMarketplace from "./BrandMarketplace";
import BrandMarketplaceProduct
    from "./BrandMarketplaceProduct";

import MarketplaceCart
    from "./MarketplaceCart";

import MarketplaceCheckout
    from "./MarketplaceCheckout";

import BrandOrders from "./BrandOrders";
import BrandFulfillment from "./BrandFulfillment";
import BrandCustomers from "./BrandCustomers";
import BrandInventory from "./BrandInventory";
import BrandBookings from "./BrandBookings";
import BrandPayments from "./BrandPayments";
import BrandMarketing from "./BrandMarketing";
import BrandBranding from "./BrandBranding";
import BrandAnalytics from "./BrandAnalytics";
import BrandCRM from "./BrandCRM";
import BrandSupport from "./BrandSupport";
import BrandSettings from "./BrandSettings";

import DeliveryPartnerOnboarding
    from "../delivery/pages/DeliveryPartnerOnboarding";

import DeliveryPartnerManagement
    from "../delivery/pages/DeliveryPartnerManagement";



export default function Brand() {

    const { user } = useAuth();

    const {

        brand,

        draftBrand,

        hasBrand,

        loading,

        refreshBrand

    } = useBrand();



    if (!user) {

        return <Navigate to="/login" replace />;

    }



    /*
    -------------------------
    Loading
    -------------------------
    */

    if (loading) {

        return (

            <div
                style={{
                    minHeight: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: 20,
                    fontWeight: 600
                }}
            >
                Loading Brand...
            </div>

        );

    }



    /*
    -------------------------
    Active Brand
    -------------------------
    */

    if (hasBrand && brand) {

        return (

            <CartProvider>

                <BrandProductProvider
                    brandId={brand.id}
                >

                    <Routes>

                        <Route
                            element={
                                <BrandDashboard
                                    brand={brand}
                                />
                            }
                        >

                            <Route
                                index
                                element={
                                    <BrandOverview
                                        brand={brand}
                                    />
                                }
                            />



                            <Route
                                path="products"
                                element={
                                    <BrandProducts
                                        brand={brand}
                                    />
                                }
                            />



                            <Route
                                path="services"
                                element={
                                    <BrandServices
                                        brand={brand}
                                    />
                                }
                            />



                            <Route
                                path="marketplace"
                                element={
                                    <BrandMarketplace
                                        brand={brand}
                                    />
                                }
                            />



                            <Route
                                path="marketplace/:productId"
                                element={
                                    <BrandMarketplaceProduct
                                        brand={brand}
                                    />
                                }
                            />



                            <Route
                                path="cart"
                                element={
                                    <MarketplaceCart />
                                }
                            />



                            <Route
                                path="checkout"
                                element={
                                    <MarketplaceCheckout />
                                }
                            />



                            <Route
                                path="orders"
                                element={
                                    <BrandOrders
                                        brand={brand}
                                    />
                                }
                            />



                            <Route
                                path="fulfillment"
                                element={
                                    <BrandFulfillment
                                        brand={brand}
                                    />
                                }
                            />



                            <Route
                                path="delivery-partner/onboarding"
                                element={
                                    <DeliveryPartnerOnboarding />
                                }
                            />



                            <Route
                                path="delivery/partners"
                                element={
                                    <DeliveryPartnerManagement
                                        brand={brand}
                                    />
                                }
                            />



                            <Route
                                path="customers"
                                element={
                                    <BrandCustomers
                                        brand={brand}
                                    />
                                }
                            />



                            <Route
                                path="inventory"
                                element={
                                    <BrandInventory
                                        brand={brand}
                                    />
                                }
                            />



                            <Route
                                path="bookings"
                                element={
                                    <BrandBookings
                                        brand={brand}
                                    />
                                }
                            />



                            <Route
                                path="payments"
                                element={
                                    <BrandPayments
                                        brand={brand}
                                    />
                                }
                            />



                            <Route
                                path="marketing"
                                element={
                                    <BrandMarketing
                                        brand={brand}
                                    />
                                }
                            />



                            <Route
                                path="branding"
                                element={
                                    <BrandBranding
                                        brand={brand}
                                    />
                                }
                            />



                            <Route
                                path="analytics"
                                element={
                                    <BrandAnalytics
                                        brand={brand}
                                    />
                                }
                            />



                            <Route
                                path="crm"
                                element={
                                    <BrandCRM
                                        brand={brand}
                                    />
                                }
                            />



                            <Route
                                path="support"
                                element={
                                    <BrandSupport
                                        brand={brand}
                                    />
                                }
                            />



                            <Route
                                path="settings"
                                element={
                                    <BrandSettings
                                        brand={brand}
                                    />
                                }
                            />

                        </Route>

                    </Routes>

                </BrandProductProvider>

            </CartProvider>

        );

    }



    /*
    -------------------------
    Resume Draft Wizard
    -------------------------
    */

    if (draftBrand) {

        return (

            <BrandSetupWizard

                existingBrand={draftBrand}

                onFinished={refreshBrand}

            />

        );

    }



    /*
    -------------------------
    Start New Wizard
    -------------------------
    */

    return (

        <BrandSetupWizard

            existingBrand={null}

            onFinished={refreshBrand}

        />

    );

}